module.exports = __webpack_public_path__ + "img/stade-brestois-logo-icon.9e5cfb12.png";